import { useLocation } from "react-router-dom";

export default function useQueryParams<T extends keyof S, S extends Record<string, string | undefined>>(params: T[]): Pick<S, T> {
  const queryParams = new URLSearchParams(useLocation().search)

  return params.reduce((current, next) => {
    return {...current, [next]: queryParams.get(next as string) }
  }, {}) as Pick<S, T>
 }